export const getFilenameFromUrl = (url: string): string => {
  const pathname = new URL(url).pathname
  const index = pathname.lastIndexOf('/')
  return -1 !== index ? pathname.substring(index + 1) : pathname
}
